var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarHarvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.872C8 19.248 7 23.5 7 27H21C21 23.54 20.024 19.35 19.036 15.994M14 11V1H15C16.0609 1 17.0783 1.42143 17.8284 2.17157C18.5786 2.92172 19 3.93913 19 5V7C19 8.06087 18.5786 9.07828 17.8284 9.82843C17.0783 10.5786 16.0609 11 15 11H14Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11H13C11.9391 11 10.9217 11.4214 10.1716 12.1716C9.42143 12.9217 9 13.9391 9 15V17C9 18.0609 9.42143 19.0783 10.1716 19.8284C10.9217 20.5786 11.9391 21 13 21H14V11ZM14 11H24V12C24 13.0609 23.5786 14.0783 22.8284 14.8284C22.0783 15.5786 21.0609 16 20 16H18C16.9391 16 15.9217 15.5786 15.1716 14.8284C14.4214 14.0783 14 13.0609 14 12V11ZM14 11V10C14 8.93913 13.5786 7.92172 12.8284 7.17157C12.0783 6.42143 11.0609 6 10 6H8C6.93913 6 5.92172 6.42143 5.17157 7.17157C4.42143 7.92172 4 8.93913 4 10V11H14Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarHarvest);
export default __webpack_public_path__ + "static/media/navbar-harvest.029aed30373412faf84710e5ce2614c9.svg";
export { ForwardRef as ReactComponent };